import {getCSRF_Token} from "@/fonction/logConnection";
import adherentMock from "@/mock/getAdherent.json";
import {AdherentBase} from "@/ts/adherent";
import {Pagination} from "@/ts/pagination";

import {callApi, getDataMock} from "./_callApi";

export async function getAdherents(): Promise<{
  adherents: AdherentBase[];
  pagination: Pagination;
}> {
  try {
    if (getDataMock()) {
      return adherentMock;
    } else return adherentMock;
  } catch (error: unknown) {
    throw new Error(
      "Erreur lors de la récupération des adhérents : " +
        (error as Error).message
    );
  }
}

export async function getAdherentInfo(API: string): Promise<any> {
  try {
    if (
      //getDataMock()
      false
    ) {
      return;
    } else {
      const reponse = await callApi(
        `${API}/api/coact/v1/me`,
        "GET",
        {
          "Content-Type": "application/json",
          "X-CSRF-Token": getCSRF_Token(),
        },
        "include"
      );
      return reponse;
    }
  } catch (error: unknown) {
    throw new Error(
      "Erreur lors de la récupération des informations de l'adhérent : " +
        (error as Error).message
    );
  }
}
